export const MENTION_CLASS = 'ov-mention';
